import Phaser from "phaser";

export default class WaitingRoom extends Phaser.Scene {
  constructor() {
    super("WaitingRoom");
    this.state = {};
    this.hasBeenSet = false;
  }

  init(data) {
    this.socket = data.socket;
  }

  preload() {
    this.load.html("codeform", "assets/text/codeform.html");
    this.load.html("roomlistform", "assets/text/roomlistform.html");
    this.load.html("ads", "assets/text/ads.html");
    this.load.font("Kenney Thick", "/assets/fonts/KenneyThick.ttf");
  }

  create() {
    const self = this;

    self.popUp = self.add.graphics();
    self.boxes = self.add.graphics();

    const popUp = {
      width: 910,
      height: 670,
      x: 49,
      y: 25,
    };

    // for popup window
    self.popUp.lineStyle(1, 0x3e5159);
    self.popUp.fillStyle(0xffffff, 0.8);

    // for boxes
    self.boxes.lineStyle(1, 0xffffff);
    self.boxes.fillStyle(0xdedede, 1);

    // popup window
    self.popUp.strokeRoundedRect(
      popUp.x,
      popUp.y,
      popUp.width,
      popUp.height,
      16
    );
    self.popUp.fillRoundedRect(popUp.x, popUp.y, popUp.width, popUp.height, 16);

    //title
    self.title = self.add.text(204, 80, "Maze Runner IO", {
      fill: "#C1D2D9",
      fontSize: "45px",
      fontStyle: "bold",
      fontFamily: "Kenney Thick",
      stroke: "#3E5159",
      strokeThickness: 10,
      shadow: {
        color: "#3E5159",
        fill: true,
        offsetX: 5,
        offsetY: 5,
        blur: 10,
      },
    });
    self.title.x = popUp.x + (popUp.width - self.title.width) / 2;

    //left popup
    self.boxes.strokeRoundedRect(169, 205, 325, 100, 8);
    self.boxes.fillRoundedRect(169, 205, 325, 100, 8);
    self.requestButton = self.add.text(184, 230, "Request Room Key", {
      fill: "#3E5159",
      fontSize: "12px",
      fontFamily: "Kenney Thick",
    });
    self.requestButton.x = 169 + (325 - self.requestButton.width) / 2;

    //right popup
    self.boxes.strokeRoundedRect(514, 205, 325, 100, 8);
    self.boxes.fillRoundedRect(514, 205, 325, 100, 8);
    self.inputElement = self.add.dom(674, 245).createFromCache("codeform");
    self.inputElement.addListener("click");
    self.inputElement.on("click", function (event) {
      if (event.target.name === "enterRoom") {
        const key = self.inputElement.getChildByName("room-key");
        const playerName = self.inputElement.getChildByName("player-name");
        const isPrivate = self.inputElement.getChildByName("private-room");
        self.socket.emit("isKeyValid", {
          roomKey: key.value,
          playerName: playerName.value,
          isPrivate: isPrivate.checked,
        });
      }
    });

    self.requestButton.setInteractive();
    self.requestButton.on("pointerdown", () => {
      self.socket.emit("getRoomCode");
    });

    //Ads
    self.boxes.strokeRoundedRect(169, 325, 325, 285, 8);
    self.boxes.fillRoundedRect(169, 325, 325, 285, 8);

    self.ads = self.add.dom(180, 342.5).createFromCache("ads").setOrigin(0, 0);

    //Rooms
    self.boxes.strokeRoundedRect(514, 325, 325, 285, 8);
    self.boxes.fillRoundedRect(514, 325, 325, 285, 8);
    self.roomsTitle = self.add.text(514, 350, "Rooms", {
      fill: "#3E5159",
      fontSize: "12px",
      fontFamily: "Kenney Thick",
    });
    self.roomsTitle.x = 514 + (325 - self.roomsTitle.width) / 2;

    self.roomList = self.add
      .dom(524, 385)
      .createFromCache("roomlistform")
      .setOrigin(0, 0);

    self.notValidText = self.add.text(549, 280, "", {
      fill: "#ff0000",
      fontSize: "10px",
      fontFamily: "Kenney Thick",
    });

    self.roomKeyText = self.add.text(289, 255, "", {
      fill: "#59C135",
      font: "35px Open Sans",
    });

    self.socket.on("roomCreated", function (roomKey) {
      self.roomKey = roomKey;
      self.roomKeyText.setText(self.roomKey);
      self.roomKeyText.x = 169 + (325 - self.roomKeyText.width) / 2;
      const domInput = self.inputElement.getChildByName("room-key");
      domInput.value = self.roomKey;
    });

    self.socket.on("keyNotValid", function () {
      self.notValidText.setText("Invalid Room Key");
      self.notValidText.x = 514 + (325 - self.notValidText.width) / 2;
    });
    self.socket.on("gameAlreadyStarted", function () {
      self.notValidText.setText("Game Already Started");
      self.notValidText.x = 514 + (325 - self.notValidText.width) / 2;
    });

    self.socket.on("nameNotValid", function () {
      self.notValidText.setText("Invalid Name");
      self.notValidText.x = 514 + (325 - self.notValidText.width) / 2;
    });

    self.socket.on("roomFull", function () {
      self.notValidText.setText("Room is Full");
      self.notValidText.x = 514 + (325 - self.notValidText.width) / 2;
    });

    self.socket.on("keyIsValid", function (input) {
      self.socket.emit("joinRoom", input);
      self.scene.stop("WaitingRoom");
    });
  }
}
